/**
 * Data mixins
 * @module data
 */

const data = {
  data () {
    return {
      /**
       * Common <v-data-table /> observables
       */
      headers: [],
      items: []
    }
  }
}

export default data



// WEBPACK FOOTER //
// ./src/helpers/data.js